export default __webpack_public_path__ + "static/media/dhcpOff.52c6a7bb.png";